export default __webpack_public_path__ + "static/media/iam_background_s1.c8d23404.jpg";